import { createClient, postRequestFactory, SaveOperation, SearchOperation, searchRequestFactory } from '@infuse/api/common';

const client = createClient('/rest/operator-api');

export type AssetInviteStatus = 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'EXPIRED';
export type AssetType = 'CHARGING_STATION' | 'POOL';

export interface AssetInviteDto {
  id: string;
  status: AssetInviteStatus;
  assetId: string;
  assetType: AssetType;
  targetEmail: string;
  invitedAt: string;
  completedAt: string | null;
  // Both null means a domain user sent the invite; they belong to no organisation or tenant.
  fromOrganisationId: string | null;
  fromTenantId: string | null;
}

// Matches the scope names the platform ABAC scope filter uses, so its translations apply.
export type AssetInviteScope = 'domain' | 'tenant' | 'organisation';

export function assetInviteScope(invite: AssetInviteDto): AssetInviteScope {
  if (invite.fromOrganisationId) return 'organisation';
  if (invite.fromTenantId) return 'tenant';
  return 'domain';
}

export const assetInvitePermissions = {
  SEARCH: 'cpms.search-asset-invites',
  CANCEL: 'cpms.cancel-asset-invite'
};

export const getAssetInvites: SearchOperation<AssetInviteDto> = searchRequestFactory<AssetInviteDto>(client, {
  pattern: '/asset-invites',
  permissionId: assetInvitePermissions.SEARCH
});

export const cancelAssetInvite: SaveOperation<void, AssetInviteDto, string> = postRequestFactory<
  void,
  AssetInviteDto,
  string
>(client, {
  pattern: '/asset-invites/{inviteId}/cancel',
  permissionId: assetInvitePermissions.CANCEL
});
